// 9fbef606107a605d69c0edbcd8029e5d
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import {
  GLOBAL_ADD_TO_BAG_MODAL_LABELS,
  GlobalAddToBagLabels,
} from '@tcp/core/src/utils/labels/globalAddedToBag.labels';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '@tcp/core/src/utils/labels/labelUtilty';
import { getIsExtendedPreorder } from '@tcp/core/src/utils';
import styles from '../styles/AfterPayMessaging.style';
import BodyCopy from '../../../atoms/BodyCopy';
import { getIconPath } from '../../../../../utils';
import Modal from '../../../molecules/Modal';

const getDynamicLabel = (label = '', replaceText, hideIntroText, replaceText1 = '') => {
  let labelText = label.replace(/#placeholder/, replaceText);
  if (replaceText1) {
    labelText = labelText.replace(/#placeholder1/, replaceText1);
  }
  return hideIntroText
    ? labelText.replace(/^(or|Or|in|In|Pay| pay| Pay in|pay in)/g, '')
    : labelText;
};

const getAfterPayIcon = (isPDPRedesignAfterPayMessage, isCashAppAfterpayLogoEnabled) => {
  if (isCashAppAfterpayLogoEnabled) return getIconPath('cashapp-afterpay-logo-black');
  return isPDPRedesignAfterPayMessage
    ? getIconPath('afterpay-logo-black')
    : getIconPath('Afterpay_Badge_BlackonMint');
};

const getAfterPayPDPRedesignClass = (isPDPRedesignAfterPayMessage) => {
  return isPDPRedesignAfterPayMessage ? ' pdp-redesign-afterpay-message' : '';
};

const getAvailableOverLabel = (isPDPRedesignAfterPayMessage, availableOverLabel) => {
  if (isPDPRedesignAfterPayMessage) {
    const updatedAvailabelOverLabel = availableOverLabel.replace(
      /\$(\d+(\.\d+)?)/g,
      '<span class="boldmessaging-text">$$$1</span>'
    );
    return (
      <BodyCopy
        className="messaging-text"
        fontFamily="secondary"
        fontSize="fs11"
        component="span"
        dangerouslySetInnerHTML={{ __html: updatedAvailabelOverLabel }}
      />
    );
  }
  return (
    <BodyCopy className="messaging-text" fontFamily="secondary" fontSize="fs11" component="span">
      {availableOverLabel}
    </BodyCopy>
  );
};

const getShowUpperLimit = (
  cartHaveGCItem,
  offerPrice,
  afterPayMaxOrderAmount,
  isOrderThresholdEnabled
) => {
  return !cartHaveGCItem && isOrderThresholdEnabled && +offerPrice > afterPayMaxOrderAmount;
};

const AfterPayMessaging = (props) => {
  const {
    className,
    isAfterPayEnabled,
    offerPrice,
    afterPayMinAmount,
    cartHaveGCItem,
    isOrderThresholdEnabled,
    afterPayMinOrderAmount,
    afterPayMaxOrderAmount,
    hideIntroText,
    preOrderDate,
    extendedOrderThreshold,
    isPDPRedesignAfterPayMessage,
    isCashAppAfterpayLogoEnabled,
  } = props;

  const globalAddedToBagLabels = getLabelFromCopyOrFromTranslation(
    GLOBAL_ADD_TO_BAG_MODAL_LABELS,
    GlobalAddToBagLabels
  );

  const afterPayLabels = {
    interestFreeText: renderLabel(
      globalAddedToBagLabels.lbl_bnpla_interest_free_text,
      'lbl_bnpla_interest_free_text'
    ),
    notAvailableText: renderLabel(
      globalAddedToBagLabels.lbl_bnpla_not_available_text,
      'lbl_bnpla_not_available_text'
    ),
    availableRangeText: renderLabel(
      globalAddedToBagLabels.lbl_bnpla_available_range_text,
      'lbl_bnpla_available_range_text'
    ),
    availableOverText: renderLabel(
      globalAddedToBagLabels.lbl_bnpla_available_over_text,
      'lbl_bnpla_available_over_text'
    ),
  };
  const orderMinAmount = isOrderThresholdEnabled ? afterPayMinOrderAmount : afterPayMinAmount;
  const showUpperLimit = getShowUpperLimit(
    cartHaveGCItem,
    offerPrice,
    afterPayMaxOrderAmount,
    isOrderThresholdEnabled
  );
  const showLowerLimit = !cartHaveGCItem && +offerPrice > orderMinAmount && !showUpperLimit;
  const dataUpperLimit = showUpperLimit ? afterPayMaxOrderAmount : '';
  const [infoModalOpen, setInfoModalOpen] = useState(false);
  const interestFreeLabel = getDynamicLabel(
    afterPayLabels.interestFreeText,
    (offerPrice / 4).toFixed(2),
    hideIntroText
  );
  const availableOverLabel = cartHaveGCItem
    ? afterPayLabels.notAvailableText
    : getDynamicLabel(
        showUpperLimit ? afterPayLabels.availableRangeText : afterPayLabels.availableOverText,
        orderMinAmount,
        false,
        dataUpperLimit
      );
  if (preOrderDate && getIsExtendedPreorder(preOrderDate, extendedOrderThreshold)) {
    return null;
  }

  const afterPayIcon = getAfterPayIcon(isPDPRedesignAfterPayMessage, isCashAppAfterpayLogoEnabled);

  return isAfterPayEnabled && offerPrice ? (
    <div
      className={`${className}${getAfterPayPDPRedesignClass(isPDPRedesignAfterPayMessage)}${
        isCashAppAfterpayLogoEnabled ? ' cashapp-afterpay-rebranding-wrapper' : ''
      }`}
      key={`afterPay_${Math.random()}`}
    >
      <div className={`afterPayMessagingWrapper`}>
        <BodyCopy
          className="messaging-text-wrapper"
          fontFamily="secondary"
          fontSize="fs11"
          component="p"
        >
          {showLowerLimit && (
            <BodyCopy
              className="messaging-text"
              fontFamily="secondary"
              fontSize="fs11"
              component="span"
            >
              {interestFreeLabel.slice(0, 31)}
              <span className="boldmessaging-text">{interestFreeLabel.slice(31, 38)}</span>
              {interestFreeLabel.slice(38)}
            </BodyCopy>
          )}
          <BodyCopy className="afterPayImage" component="span">
            <img src={afterPayIcon} alt="after-pay" />
          </BodyCopy>
          {showLowerLimit ? (
            ' '
          ) : (
            <>{getAvailableOverLabel(isPDPRedesignAfterPayMessage, availableOverLabel)}</>
          )}
          <BodyCopy
            accessibilityRole="button"
            className="info-icon-wrapper"
            component="span"
            tabIndex="0"
            onClick={() => {
              setTimeout(() => {
                setInfoModalOpen(true);
              }, 0);
            }}
          >
            <img
              className="styledInfoIcon"
              width="12px"
              height="12px"
              src={getIconPath('info-icon')}
              alt="info"
            />
          </BodyCopy>
        </BodyCopy>
      </div>
      <Modal
        isOpen={infoModalOpen}
        overlayClassName="TCPModal__Overlay"
        className="TCPModal__Content"
        fixedWidth
        maxWidth="100vw"
        minHeight="520px"
        heightConfig={{ maxHeight: '100%', height: '660px' }}
        widthConfig={{ medium: '774px', large: '774px' }}
        noPadding
        onRequestClose={() => setInfoModalOpen(false)}
        stickyCloseIcon
        horizontalBar={false}
      >
        <iframe
          src="https://static.afterpay.com/modal/en_US-theme-white.html"
          title="Afterpay modal"
          width="100%"
          height="100%"
          scrolling="yes"
          frameBorder="0"
        />
      </Modal>
    </div>
  ) : null;
};

AfterPayMessaging.propTypes = {
  offerPrice: PropTypes.number,
  isAfterPayEnabled: PropTypes.bool.isRequired,
  afterPayMinAmount: PropTypes.string.isRequired,
  cartHaveGCItem: PropTypes.bool,
  isOrderThresholdEnabled: PropTypes.bool,
  afterPayMinOrderAmount: PropTypes.number,
  hideIntroText: PropTypes.bool,
  afterPayMaxOrderAmount: PropTypes.number,
  preOrderDate: PropTypes.string,
  extendedOrderThreshold: PropTypes.number,
};

AfterPayMessaging.defaultProps = {
  offerPrice: 0,
  cartHaveGCItem: false,
  isOrderThresholdEnabled: false,
  afterPayMinOrderAmount: 0,
  hideIntroText: false,
  afterPayMaxOrderAmount: 0,
  preOrderDate: '',
  extendedOrderThreshold: 0,
};

export default withStyles(AfterPayMessaging, styles);
export { AfterPayMessaging as AfterPayMessagingVanilla };
